<div class="moved-in-out-dialog">
  <div class="tabs-summary-row">
    <p-tabs [value]="activeTab.id" 
    (valueChange)="onTabMenuChange($event)">
      <p-tablist>
        @for (tab of movementTabs; track tab.id) {
          <p-tab [value]="tab.id" class="font-bold">{{ tab.label }}</p-tab>
        }
      </p-tablist>
    </p-tabs>

    <div class="route-summary">
      <div class="summary-item"><span>Route Name -<b> {{ routeDetails?.route_label }}</b></span></div>
      <div class="summary-item"><span>Route State -<b> {{ routeDetails?.route_state }}</b></span></div>
      <div class="summary-item"><span>Route Begin -<b> {{ routeDetails?.route_time_window?.begin | dateFormat : 'datetime'}}</b></span></div>
      <div class="summary-item"><span>Route End -<b> {{ routeDetails?.route_time_window?.end | dateFormat : 'datetime'}}</b></span></div>
    </div>
    <div class="pointer-cursor wrap-btn">
      <img width="20" (click)="wrapUnwrap = !wrapUnwrap" height="20" pTooltip="Wrap/Unwrap" tooltipPosition="left"
        positionStyle="fixed" src="./assets/image/wrap.svg" alt="wrap/unwrap" />
    </div>
  </div>

  <div *ngIf="isLoading" class="loading-container">
    <div class="text-center no-record-label">Loading...</div>
  </div>

  <ng-container
    *ngIf="!isLoading"
    [ngTemplateOutlet]="table"
    [ngTemplateOutletContext]="{ rows: currentRows }">
  </ng-container>
</div>

<ng-template #table let-rows="rows">
  <p-table [value]="rows"
    [scrollable]="true"
    scrollHeight="calc(60vh - 150px)"
    [sortMode]="'single'">
    <ng-template pTemplate="header">
      <tr>
        <ng-container *ngFor="let col of currentColumns">
          <th *ngIf="col.id !== 'asc' && col.id !== 'time_window'" [scope]="col.id"
            [ngClass]="wrapUnwrap ? 'breakWrapData' : 'wrapData'" style="text-align: left;min-width:80px !important;"
            pResizableColumn [pSortableColumn]="col.id" [id]="col">
            {{ col.label }} <p-sortIcon [field]="col.id" /></th>
          <th *ngIf="col.id === 'time_window' || col.id === 'asc'" [ngClass]="wrapUnwrap ? 'breakWrapData' : 'wrapData'"
            pResizableColumn style="text-align: left;min-width:80px !important;" [id]="col">
            {{ col.label }}</th>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td *ngFor="let col of currentColumns" [ngClass]="wrapUnwrap ? 'breakWrapData' : 'wrapData'">
          <ng-container *ngIf="col.id === 'asc'">
            {{ row[col.id] || '' }}
          </ng-container>
          <ng-container *ngIf="col.id === 'barcode'">
            <a href="javascript:void(0)" (click)="barcodeClicked(row)">{{ row[col.id] }}</a>
          </ng-container>
          <ng-container *ngIf="col.id === 'route_name'">
            <a href="javascript:void(0)" (click)="openRouteInfo(row)">{{ row[col.id] }}</a>
          </ng-container>
          <ng-container *ngIf="col.id !== 'asc' && col.id !== 'barcode' && col.id !== 'route_name'">
            {{ row[col.id] }}
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="currentColumns.length">
          <div class="text-center no-record-label">No records available.</div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</ng-template>